export default "https://cdn-static.gokick.com/assets/31bbee86f9627d9d8b331552e0c9ca66f3d2b554/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";